<template>
<div class="body consumer-policy-top">
	<div class="lightbluebg container">
		<div class="contexbox">
			<br /><br />
	
			<!-- <h1 class="display-5 text-white font-weight-bolder text-center">American Credit, Inc<br>Consumer Communication Policy</h1> -->
			<h1 class="display-5 text-white font-weight-bolder text-center">Consumer communication policy</h1>
	
	
			<h6 class="text-left">This Consumer Communications Policy is meant to help you
					understand how we and our affiliates use your personal contact
					information, including the email[s] and the phone number[s] that you
					provide to us, in connection with our services. By consenting to this
					policy, you authorize American Credit, Inc, our assigns, successors
					or servicing agents to use email and SMS communications (as defined
					below), artificial or prerecorded voice messages and automatic
					dialing technology, for all purposes, not prohibited by applicable
					law. This includes authorizing American Credit, Inc and/or its
					affiliates to contact you regarding the advertising or telemarketing
					of our products and services. As used in this text messaging
					disclosure, "SMS Account Communications" means any SMS (text message)
					communications from us to the phone number provided in connection
					with this transaction. Message and data rates may apply.
			</h6>
			<br /> <br />
	
		</div>
	</div>
	<br/><br/>

	<br />
	<div class="container bg-white">
		<div class="contexbox">
		<p>
			1. How to Unsubscribe: You may revoke your consent to receive email
			or phone calls, other than to service your account or collect any
			amounts you may owe, by calling us at <span>855-904-0188
				American Credit</span>, Inc or by logging into your account on American
			Credit, Inc.com and changing your TCPA Consent preference. You may
			withdraw your consent to receive SMS Account Communications by
			replying with "STOP, END, CANCEL, UNSUBSCRIBE, or QUIT" or calling us
			at <span>855-904-0188 </span>.
		</p>
		<br />
		<p>2. We may treat your provision of an invalid mobile phone
			number, or the subsequent malfunction of a previously valid mobile
			phone number, as a withdrawal of your consent to receive SMS Account
			Notifications. Any withdrawal of your consent to use SMS Account
			Notifications will be effective only after we have a reasonable
			period of time to process your withdrawal.</p>
		<br />
		<p>
			3. To request additional information; contact us by telephone at <span>855-904-0188</span>.
		</p>
		<br />
		<p>4. In order to access, view, and retain SMS Account
			Notifications that we make available to you, you must have: (i) a
			SMS-capable mobile phone, (ii) an active mobile phone account with a
			communication service provider; and (iii) sufficient storage capacity
			on your mobile phone. All email and SMS Account Communications in
			electronic format from us to you will be considered "in writing."</p>
		<br />
		<p>5. There is no service fee for email and SMS Account
			Notifications but you are responsible for any and all charges,
			including but not limited to fees associated with text messaging,
			imposed by your communications service provider. Please consult your
			mobile service carrier's pricing plan to determine the charges for
			sending and receiving text messages. These charges will appear on
			your phone bill. Message frequency depends on account status or
			settings. We may modify or terminate our text messaging services from
			time to time, for any reason, and without notice, including the right
			to terminate text messaging with or without notice, without liability
			to you.</p>
		<br />
		</div>
	</div>
</div>
</template>

<script>
export default {
	data(){
		return {

		}
	},
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Consumer Communication Policy | American Credit";
    meta.content = "Understand how we and our affiliates use your personal contact information provided to us, in connection with our services.";
    keywords.content = "Consumer Communication Policy,Communication Policy";
  }
}

</script>

<style scoped lang="scss">

.consumer-policy-top {
	margin-top: 100px;
}

@media (max-width: 768px) {
	.consumer-policy-top {
		margin-top: 0;
	}
}

#communicationPolicy { .container { margin-top:74px;h4 { font-size:19px;
	color: #000;
}

p {
	margin-top: 30px;
	line-height: 32px;
	color: #555555;
	font-size: 16px;
	span
	{
	color
	:
	#555555;
}

}
.last {
	padding-bottom: 100px;
}
}
}
</style>


// WEBPACK FOOTER //
// communicationPolicy.vue?270a7c57